import { IPermissionEdit } from "./IPermissionEdit"

export class PermissionAppointments {

    public selectAllPermissionAppointments!:IPermissionEdit
    
    public System!: {
        selectAll: boolean;

        viewSystemSettings: IPermissionEdit;
        editSystem: IPermissionEdit;
    }

    public Reports!: {
        selectAll: boolean;

        viewAppointmentDetailsReport: IPermissionEdit;
        viewCampaignSummaryReport: IPermissionEdit;
        viewAppointmentTrendsReport: IPermissionEdit;
    }

    public Appointements!: {
        selectAll: boolean;

        appointmentsEdit: IPermissionEdit;
        appointmentsView: IPermissionEdit;
        appointmentsAdd: IPermissionEdit;
        appointmentsDelete: IPermissionEdit;
        ExceptionsAdd: IPermissionEdit;
        ExceptionsEdit: IPermissionEdit;
        ExceptionsDelete: IPermissionEdit;
    }

    public ViewActionCenter!: {
        selectAll: boolean;

        viewActionCenter: IPermissionEdit;
        editActionCenter: IPermissionEdit;


        changeAppointmentAssignment: IPermissionEdit;
        sendFollowUpEnable: IPermissionEdit;
        bulkDeleteAppointments: IPermissionEdit;
        changeAppointmentStatus: IPermissionEdit;

        isInputValid: boolean;
    }

    public SystemSettings!: {
        selectAll: boolean;


    
        viewSystemSettings: IPermissionEdit;      
        editSystemSettings: IPermissionEdit;
         
    }

    // AC Administration settings
    public Administration!: {
        selectAll: boolean;
        ViewEditAdministration: IPermissionEdit;
        ViewEditEventSettings: IPermissionEdit;
    }

    // AC Campaigns settings
    public Campaigns!: {
        selectAll: boolean;
        ViewCampaigns: IPermissionEdit;
        AddCampaigns: IPermissionEdit;
        EditCampaigns: IPermissionEdit;
        DeleteCampaigns: IPermissionEdit;
    }

    // AC Event settings
    public Events!: {
        selectAll: boolean;
        ViewEvents: IPermissionEdit;
        AddEvents: IPermissionEdit;
        EditEvents: IPermissionEdit;
        ActivateDeactivateEvents: IPermissionEdit;
    }
}